let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("f9Fpn")).then(() => parcelRequire('5uhwr'));